module.exports = __webpack_public_path__ + "img/adviser-enrolment-footer.7e937abf.png";